if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.selectSizeNotice = this.querySelector('[data-select-size-notice]');
        this.hideSelectSizeNotice();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.hideSelectSizeNotice();
        if (this.submitButton.classList.contains('scroll-to-options')) {
          this.showSelectSizeNotice();
          const $formInputGroups = document.querySelectorAll('.js-product-form-input');
          let $formInputGroupWithNoOptionSelected;
          $formInputGroups.forEach(($inputGroup) => {
            const $inputSelected = $inputGroup.querySelector('.js-product-swatch:checked');
            if (!$inputSelected && !$formInputGroupWithNoOptionSelected) {
              $formInputGroupWithNoOptionSelected = $inputGroup;
            }
          });

          if ($formInputGroupWithNoOptionSelected) {
            const rect = $formInputGroupWithNoOptionSelected.getBoundingClientRect();
            const scrollTop = window.scrollY || window.pageYOffset;
            const elementY = rect.top + scrollTop;
            const offset = window.innerHeight / 2 - rect.height / 2;

            window.scrollTo({
              top: elementY - offset,
              behavior: 'smooth',
            });
          }
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            // Show success state for 2 seconds
            this.showSuccessState();

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showSuccessState() {
        // Add success class to show green background and check icon
        this.submitButton.classList.add('success');

        // Remove success state after 2 seconds
        setTimeout(() => {
          this.submitButton.classList.remove('success');
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, shipsLater, hide = false) {
        this.hideSelectSizeNotice();
        const { isGiftCard } = this.submitButton.dataset || {};
        if (disable) {
          if (text) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButtonText.textContent = text;
          } else {
            this.submitButton.classList.add('scroll-to-options');
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('scroll-to-options');
          if (isGiftCard) {
            this.submitButtonText.textContent = window.variantStrings.chooseRecipient;
          } else if (shipsLater) {
            const dateString = shipsLater.replace(/-/g, '/');
            const originalDate = new Date(dateString);
            const datePlus7Days = new Date(originalDate);
            datePlus7Days.setDate(datePlus7Days.getDate() + 7);
            const options = { month: 'short', day: 'numeric' };
            const locale = Shopify.locale && Shopify.country ? `${Shopify.locale}-${Shopify.country}` : 'en-US';
            const formattedDate1 = originalDate.toLocaleDateString(locale, options);
            const formattedDate2 = datePlus7Days.toLocaleDateString(locale, options);
            this.submitButtonText.textContent = window.variantStrings.preorder
              .replace('[date_1]', formattedDate1)
              .replace('[date_2]', formattedDate2);
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        if (hide) {
          this.submitButton.classList.add('hide');
        } else {
          this.submitButton.classList.remove('hide');
        }
      }

      showSelectSizeNotice() {
        if (!this.selectSizeNotice) return;
        this.selectSizeNotice.hidden = false;
      }

      hideSelectSizeNotice() {
        if (!this.selectSizeNotice) return;
        this.selectSizeNotice.hidden = true;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
